import React from 'react';
import { Box, Typography, Container, Grid, Button } from '@mui/material';
import { Smartphone, LocalTaxi } from '@mui/icons-material';
import NavbarClient from '../components/NavbarClient';
import ProfessionalPricingSection from '../components/Planos/ProfessionalPricingSection';
import HowItWorksSection from '../components/Planos/HowItWorksSection';
import BenefitsSection from '../components/Planos/BenefitsSection';
import Footer from '../components/Footer';
import carWashHero from '../assets/car-wash-hero.jpg';
import './Planos.scss';

const ProfessionalHero = () => {
  return (
    <section className="hero-gradient">
      <Container
        maxWidth="lg"
        sx={{
          py: { xs: 8, lg: 10 },
          pt: { xs: 12, lg: 14 },
          position: 'relative',
          zIndex: 10,
        }}
      >
        <Grid container spacing={4} alignItems="center" paddingTop={10}>
          <Grid item xs={12} lg={6}>
            <Box sx={{ textAlign: { xs: 'center', lg: 'left' } }} className="animate-fade-in">
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: { xs: 'center', lg: 'flex-start' },
                gap: 1,
                mb: 2
              }}>
                <LocalTaxi sx={{ color: '#06b6d4', width: 20, height: 20 }} />
                <Typography
                  variant="body2"
                  sx={{
                    color: '#06b6d4',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}
                >
                  Planos para Motoristas
                </Typography>
              </Box>

              <Typography
                variant="h1"
                className="text-hero"
                sx={{
                  color: 'white',
                  mb: 3,
                  fontSize: { xs: '2.5rem', md: '3.5rem', lg: '4rem' },
                  fontWeight: 800,
                  lineHeight: 1.1
                }}
              >
                Planos exclusivos para
                <Box component="span" sx={{ color: '#06b6d4' }}>
                  {' '}motoristas profissionais
                </Box>
              </Typography>

              <Typography
                variant="h6"
                sx={{
                  color: 'rgba(255, 255, 255, 0.8)',
                  mb: 4,
                  maxWidth: { xs: '100%', lg: '500px' },
                  mx: { xs: 'auto', lg: 0 },
                  lineHeight: 1.6
                }}
              >
                Ideal para motoristas de Uber, 99 e Táxi. Mantenha seu carro sempre limpo
                com planos acessíveis e atendimento em lava-rápidos selecionados.
              </Typography>

              <Button
                variant="contained"
                size="large"
                startIcon={<Smartphone />}
                href="/app-download"
                sx={{
                  backgroundColor: '#06b6d4',
                  color: 'white',
                  fontWeight: 600,
                  px: 4,
                  py: 2,
                  boxShadow: '0 4px 15px rgba(6, 182, 212, 0.3)',
                  '&:hover': {
                    backgroundColor: '#0891b2',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 6px 20px rgba(6, 182, 212, 0.4)'
                  },
                  transition: 'all 0.3s ease'
                }}
              >
                Baixar App Grátis
              </Button>
            </Box>
          </Grid>

          <Grid item xs={12} lg={6}>
            <Box
              sx={{
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
                transform: { lg: 'scale(1.1)' }
              }}
              className="animate-fade-in"
              style={{ animationDelay: '0.3s' }}
            >
              <Box sx={{ position: 'relative', maxWidth: '300px', width: '100%' }}>
                <Box
                  sx={{
                    position: 'absolute',
                    inset: 0,
                    backgroundColor: 'rgba(6, 182, 212, 0.3)',
                    borderRadius: '1.5rem',
                    filter: 'blur(24px)',
                    transform: 'scale(1.05)'
                  }}
                />
                <Box
                  sx={{
                    position: 'relative',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(8px)',
                    borderRadius: '1.5rem',
                    p: 2,
                    border: '1px solid rgba(255, 255, 255, 0.2)'
                  }}
                >
                  <Box
                    component="img"
                    src={carWashHero}
                    alt="Carro sendo lavado profissionalmente"
                    sx={{
                      width: '100%',
                      height: 'auto',
                      borderRadius: '1rem'
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    position: 'absolute',
                    top: -16,
                    right: -16,
                    width: 64,
                    height: 64,
                    backgroundColor: 'rgba(6, 182, 212, 0.2)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backdropFilter: 'blur(8px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)'
                  }}
                >
                  <LocalTaxi sx={{ color: '#06b6d4', width: 32, height: 32 }} />
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>

      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: 64,
          '& svg': {
            width: '100%',
            height: '100%',
            color: '#ffffff'
          }
        }}
      >
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" fill="currentColor">
          <path d="M0,120 C300,80 900,40 1200,80 L1200,120 Z" />
        </svg>
      </Box>
    </section>
  );
};

const Profissional = () => {
  return (
    <div className="planos-page">
      <NavbarClient />
      <main>
        <ProfessionalHero />
        <ProfessionalPricingSection />
        <HowItWorksSection />
        <BenefitsSection />
      </main>
      <Footer />
    </div>
  );
};

export default Profissional;
